import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { EnvService } from 'src/app/services/env.service';

@Pipe({
  name: 'userIsBlocked',
})
export class UserIsBlockedPipe implements PipeTransform {
  constructor(private readonly http: HttpClient, private env: EnvService) { }

  isBlocked(id): Promise<boolean> {
    return new Promise((resolve) => {
      this.http
        .get<boolean>(`${this.env.URL_API_V1}/user/blocked/${id}`)
        .subscribe({
          next: (res) => {
            resolve(res);
          },
        });
    });
  }
  async transform(user: IUser): Promise<boolean> {

    return await this.isBlocked(user._id);
  }
}
